import { NavLink } from "react-router-dom";
import type { LucideIcon } from "lucide-react";
import { ChevronRight } from "lucide-react";
import { Badge } from "../components/ui";

export interface ActionCardProps {
  to: string;
  icon: LucideIcon;
  title: string;
  description: string;
  badge?: string;
  badgeTone?: "neutral" | "success" | "warning" | "live";
}

export function ActionCard({
  to,
  icon: Icon,
  title,
  description,
  badge,
  badgeTone = "neutral",
}: ActionCardProps) {
  return (
    <NavLink
      to={to}
      className="flex items-center justify-between rounded-xl bg-surface p-4 shadow-raised transition-colors active:bg-app-field"
    >
      <span className="flex min-w-0 items-center gap-4">
        <span className="grid h-12 w-12 shrink-0 place-items-center rounded-xl bg-accent-soft text-accent">
          <Icon size={24} strokeWidth={1.8} />
        </span>
        <span className="flex min-w-0 flex-col">
          <span className="flex items-center gap-2">
            <span className="text-base font-semibold text-app-ink">{title}</span>
            {badge && <Badge tone={badgeTone}>{badge}</Badge>}
          </span>
          <span className="mt-0.5 truncate text-sm text-app-muted">{description}</span>
        </span>
      </span>
      <ChevronRight size={20} className="ms-3 shrink-0 text-app-icon" />
    </NavLink>
  );
}
